<template>
  <div id="projBusiOpptyListCard">
    <div class="card-header">
      <div class="card-header-left ellipsis">
        <router-link :to="'/projbid/demand/'+project.projectId+ '/' + user.userid">
          {{project.projectName}}
        </router-link>
      </div>
      <div class="card-header-right">
        <!-- <router-link :to="'/projbid/demand/'+project.projectId+ '/' + user.userid"> -->
          <el-button @click="isCheckAuth(project.projectId)" class="eb-button-red eb-button-small">查看需求</el-button>
        <!-- </router-link> -->
        <ProjBidBtnReply class="replyProject eb-button-red eb-button-small" :project="project" />
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-left">
        <img v-if="project.projectImages" :src="project.projectImages" alt="项目图片">
        <img v-if="!project.projectImages" :src="$ebConfig.imgPath+'img/project-default.jpg'" alt="项目图片">
      </div>
      <div class="card-body-right">
        <div class="card-three-row">
          <div class="col-242">
            <div class="col-left">项目编号:</div>
            <div class="col-right">
              <el-tooltip :content="project.projectCode" placement="top">
                <span class="col-right-content"> {{project.projectCode}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-210">
            <div class="col-left">当前状态:</div>
            <div class="col-right">
              <span class="col-right-content">{{project.projectStatus | projBidStatus}}</span>
            </div>
          </div>
          <div class="col-135 ">
            <span class="font-type-box">
              <eb-font-type>{{project.projectMethod | projectMethod(true)}}</eb-font-type>
              <eb-font-type>{{project.projectType | projectType(true)}}</eb-font-type>
            </span>
          </div>
          <div class="col-218">
            <eb-share/>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-588">
            <div class="col-left">采购单位:</div>
            <div class="col-right">
              <el-tooltip :content="project.buyDepartName ||'-'" placement="top">
                <span @click="conpanyInfo" class="col-right-content conpanyInfo"> {{project.buyDepartName||'-'}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">报价开始:</div>
            <div class="col-right">
              <el-tooltip :content="project.startTime | dateFormatYMDH " placement="top">
                <span class="col-right-content"> {{project.startTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-242">
            <div class="col-left">项目预算:</div>
            <div class="col-right">
              <span class="col-right-content">-</span>
            </div>
          </div>
          <div class="col-346">
            <div class="col-left">采购经办:</div>
            <div class="col-right">
              <img @click="userInfoDialog(project.buyUserId)" class="header_img" v-if="project.buyUserheadImg" :src="buyUserheadSrc">
              <img @click="userInfoDialog(project.buyUserId)" class="header_img" v-if="!project.buyUserheadImg" :src="$ebConfig.imgPath+'img/user-default.jpeg'">
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">截标时间:</div>
            <div class="col-right">
              <el-tooltip :content="project.endTime | dateFormatYMDH " placement="top">
                <span class="col-right-content"> {{project.endTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ebFontType from '@/components/common/eb-font-type';
import ebShare from '@/components/common/share/eb-share';
import eventBus from '@/plugins/event-bus';
import ProjBidBtnReply from '@/components/project/bid/list/ProjBidBtnReply';
import { isCheckSupplierBtnAuth } from '@/services/proj/bid-project-service';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'projBusiOpptyListCard',
  props: {
    project: {}
  },
  data() {
    return {
      user: this.$store.state.user.userInfo
    };
  },
  computed: {
    buyUserheadSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.buyUserheadImg + '?time=' + Date.now();
      }
    }
  },
  components: {
    ebFontType,
    ebShare,
    ProjBidBtnReply
  },
  methods: {
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    conpanyInfo() {
      window.open('/buyer/detail/' + this.project.orgId);
    },
    async isCheckAuth(projectId) {
      let params = {
        projectId: projectId,
        type: '1'
      };
      try {
        let { data } = await isCheckSupplierBtnAuth(params);
        if (data.returnCode === '01') {
          this.$router.push('/projbid/demand/' + projectId + '/' + this.user.userid);
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    }
  }
};
</script>
<style scoped lang="less">
#projBusiOpptyListCard {
  .card-header {
    display: flex;
  }
  .card-header-left {
    width: 60%;
    height: 52px;
    display: flex;
    color: #060606;
    font-weight: 700;
    font-family: 'Microsoft YaHei';
    align-items: center;
    a {
      color: #060606;
    }
  }
  .card-header-right {
    width: 40%;
    height: 52px;
    display: flex;
    align-items: center;
    line-height: 22px;
    justify-content: flex-end;
    padding-right: 1.3%;
    .replyProject {
      margin-left: 13px;
    }
  }
  .card-body {
    display: flex;
  }
  .card-body-left {
    height: 135px;
    width: 18.3%;
    display: flex;
    img {
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .card-body-right {
    width: 80.6%;
    padding-left: 1%;
  }
  .header_img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-top: 8px;
    cursor: pointer;
  }
  .font-type-box {
    padding-left: 45px;
    .eb-font-type {
      margin-left: 17px;
    }
  }
  .conpanyInfo {
    cursor: pointer;
  }
}
</style>
